// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Cookie consent — full-width banner */

.bv-cookie-consent {
  --bv-cookie-z: 90;
  position: fixed;
  inset: 0;
  z-index: var(--bv-cookie-z);
  pointer-events: none;
  display: flex;
  align-items: flex-end;
}

.bv-cookie-consent.is-visible {
  pointer-events: auto;
}

.bv-cookie-consent__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.24);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  opacity: 0;
  transition: opacity var(--bv-dur-slow) var(--bv-ease);
}

.bv-cookie-consent.is-visible .bv-cookie-consent__backdrop {
  opacity: 1;
}

.bv-cookie-consent.is-leaving .bv-cookie-consent__backdrop {
  opacity: 0;
}

.bv-cookie-consent__panel {
  position: relative;
  z-index: 1;
  width: 100%;
  background:
    radial-gradient(ellipse 80% 120% at 0% 100%, rgba(20, 184, 166, 0.12), transparent 55%),
    radial-gradient(ellipse 60% 80% at 100% 0%, rgba(251, 146, 60, 0.08), transparent 50%),
    linear-gradient(180deg, #ffffff 0%, var(--bv-bg-cream) 100%);
  border-top: 1px solid var(--bv-primary-line);
  box-shadow: 0 -20px 60px rgba(15, 23, 42, 0.14);
  transform: translateY(100%);
  opacity: 0;
  transition:
    transform 0.52s var(--bv-ease-out),
    opacity 0.38s var(--bv-ease);
}

.bv-cookie-consent.is-visible .bv-cookie-consent__panel {
  transform: translateY(0);
  opacity: 1;
}

.bv-cookie-consent.is-leaving .bv-cookie-consent__panel {
  transform: translateY(100%);
  opacity: 0;
}

.bv-cookie-consent__shell {
  width: 100%;
  max-width: calc(var(--bv-container-wide) + (2 * var(--bv-container-px)));
  margin-inline: auto;
  padding: 18px var(--bv-container-px);
  padding-bottom: max(18px, env(safe-area-inset-bottom, 0px));
  box-sizing: border-box;
}

/* Hero: copy | buttons */
.bv-cookie-consent__hero {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  align-items: center;
}

.bv-cookie-consent__body {
  min-width: 0;
}

.bv-cookie-consent__badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  margin-bottom: 8px;
  border-radius: var(--bv-radius-pill);
  background: #fff;
  border: 1px solid var(--bv-primary-line);
  color: var(--bv-primary-700);
  font-family: var(--bv-font-display);
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.bv-cookie-consent__badge i {
  font-size: 0.65rem;
  color: var(--bv-primary);
}

.bv-cookie-consent__title {
  font-family: var(--bv-font-display);
  font-size: clamp(1.125rem, 2.5vw, 1.375rem);
  font-weight: 700;
  letter-spacing: -0.03em;
  color: var(--bv-ink);
  line-height: 1.2;
  margin: 0 0 6px;
}

.bv-cookie-consent__text {
  font-size: 0.875rem;
  line-height: 1.55;
  color: var(--bv-muted);
  margin: 0 0 8px;
  max-width: 56ch;
}

.bv-cookie-consent__links {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  font-size: 0.8125rem;
}

.bv-cookie-consent__links a {
  color: var(--bv-primary-700);
  font-weight: 600;
  text-decoration: none;
  border-bottom: 1px solid var(--bv-primary-line);
  transition: color var(--bv-dur-fast) var(--bv-ease);
}

.bv-cookie-consent__links a:hover {
  color: var(--bv-primary);
}

.bv-cookie-consent__links span {
  color: var(--bv-muted-2);
}

/* Buttons — order: Reject | Accept | Settings */
.bv-cookie-consent__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.bv-cookie-consent__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 20px;
  font-family: var(--bv-font-display);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1;
  border-radius: var(--bv-radius-pill);
  border: 1px solid transparent;
  cursor: pointer;
  white-space: nowrap;
  transition:
    transform var(--bv-dur-fast) var(--bv-ease),
    box-shadow var(--bv-dur-fast) var(--bv-ease),
    background var(--bv-dur-fast) var(--bv-ease),
    border-color var(--bv-dur-fast) var(--bv-ease),
    color var(--bv-dur-fast) var(--bv-ease);
}

.bv-cookie-consent__btn--reject {
  background: #fff;
  border-color: var(--bv-line);
  color: var(--bv-ink-3);
}

.bv-cookie-consent__btn--reject:hover {
  border-color: var(--bv-muted-2);
  color: var(--bv-ink);
}

.bv-cookie-consent__btn--accept {
  background: var(--bv-grad-primary);
  color: #fff;
  box-shadow: var(--bv-shadow-teal);
  padding-inline: 24px;
}

.bv-cookie-consent__btn--accept:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 36px rgba(20, 184, 166, 0.38);
}

.bv-cookie-consent__btn--settings {
  background: #fff;
  border-color: var(--bv-line);
  color: var(--bv-ink-2);
}

.bv-cookie-consent__btn--settings:hover,
.bv-cookie-consent__btn--settings.is-active {
  border-color: var(--bv-primary);
  color: var(--bv-primary-700);
  background: var(--bv-primary-50);
}

.bv-cookie-consent__chev {
  font-size: 0.55rem !important;
  transition: transform var(--bv-dur) var(--bv-ease);
}

.bv-cookie-consent__btn--settings.is-active .bv-cookie-consent__chev {
  transform: rotate(180deg);
}

/* Settings panel */
.bv-cookie-consent__settings {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.36s var(--bv-ease-out);
}

.bv-cookie-consent__settings.is-open {
  grid-template-rows: 1fr;
}

.bv-cookie-consent__settings-inner {
  overflow: hidden;
}

.bv-cookie-consent.has-settings-open .bv-cookie-consent__shell {
  padding-bottom: max(20px, env(safe-area-inset-bottom, 0px));
}

.bv-cookie-consent__settings.is-open .bv-cookie-consent__settings-inner {
  padding-top: 16px;
  border-top: 1px solid var(--bv-line-soft);
  display: flex;
  justify-content: center;
}

/* —— Cookie preferences: centered wide toolbar —— */
.bv-cookie-consent__prefs-bar {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 6px 8px;
  background: #fff;
  border: 1px solid var(--bv-line);
  border-radius: var(--bv-radius-pill);
  box-shadow: var(--bv-shadow-xs);
  gap: 4px;
  overflow: hidden;
  box-sizing: border-box;
}

.bv-cookie-consent__seg {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
  padding: 10px 16px;
  transition: background var(--bv-dur-fast) var(--bv-ease);
}

.bv-cookie-consent__seg-name {
  font-family: var(--bv-font-display);
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--bv-ink);
  white-space: nowrap;
}

.bv-cookie-consent__seg-tag {
  font-size: 0.6875rem;
  font-weight: 600;
  color: var(--bv-primary-700);
  padding: 4px 10px;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-primary-50);
  border: 1px solid var(--bv-primary-line);
  white-space: nowrap;
}

.bv-cookie-consent__seg-divider {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 24px;
  background: var(--bv-line);
  pointer-events: none;
}

/* Toggle — reset native button chrome */
.bv-cookie-consent__switch {
  appearance: none;
  position: relative;
  flex-shrink: 0;
  width: 36px;
  height: 20px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: var(--bv-radius-pill);
  background: var(--bv-line);
  cursor: pointer;
  transition: background var(--bv-dur-fast) var(--bv-ease);
}

.bv-cookie-consent__switch::before,
.bv-cookie-consent__switch::after {
  box-sizing: border-box;
}

.bv-cookie-consent__switch::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.18);
  transition: transform 0.26s var(--bv-ease-spring);
}

.bv-cookie-consent__switch.is-on {
  background: var(--bv-primary);
}

.bv-cookie-consent__switch.is-on::after {
  transform: translateX(16px);
}

.bv-cookie-consent__switch:focus-visible {
  outline: 2px solid var(--bv-primary);
  outline-offset: 2px;
}

.bv-cookie-consent__seg-save {
  flex: 0 0 auto;
  margin: 0;
  padding: 10px 18px;
  font-family: var(--bv-font-display);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1;
  color: #fff;
  background: var(--bv-ink);
  border: none;
  border-radius: var(--bv-radius-pill);
  cursor: pointer;
  white-space: nowrap;
  transition:
    background var(--bv-dur-fast) var(--bv-ease),
    transform var(--bv-dur-fast) var(--bv-ease);
}

.bv-cookie-consent__seg-save:hover {
  background: var(--bv-ink-2);
}

/* Mobile */
@media (max-width: 767px) {
  .bv-cookie-consent__prefs-bar {
    max-width: 100%;
    padding: 5px 6px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    border-radius: var(--bv-radius-lg);
    justify-content: flex-start;
  }

  .bv-cookie-consent__prefs-bar::-webkit-scrollbar {
    display: none;
  }

  .bv-cookie-consent__seg {
    flex: 0 0 auto;
    min-width: 128px;
    padding: 9px 14px;
    gap: 10px;
  }

  .bv-cookie-consent__seg-name {
    font-size: 0.8125rem;
  }

  .bv-cookie-consent__seg-save {
    flex: 0 0 auto;
    padding: 9px 18px;
    font-size: 0.8125rem;
  }
}

@media (min-width: 768px) {
  .bv-cookie-consent__prefs-bar {
    max-width: min(100%, 800px);
    padding: 8px 10px;
  }

  .bv-cookie-consent__seg {
    padding: 11px 20px;
  }
}

/* Tablet+ */
@media (min-width: 768px) {
  .bv-cookie-consent__shell {
    padding-top: 22px;
    padding-bottom: max(22px, env(safe-area-inset-bottom, 0px));
  }

  .bv-cookie-consent__hero {
    grid-template-columns: 1fr auto;
    gap: 32px;
    align-items: center;
  }

  .bv-cookie-consent__actions {
    flex-wrap: nowrap;
    gap: 10px;
  }

  .bv-cookie-consent__settings.is-open .bv-cookie-consent__settings-inner {
    padding-top: 12px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .bv-cookie-consent__panel,
  .bv-cookie-consent__backdrop,
  .bv-cookie-consent__settings,
  .bv-cookie-consent__switch::after,
  .bv-cookie-consent__chev {
    transition: none;
  }

  .bv-cookie-consent.is-visible .bv-cookie-consent__panel {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/cookieConsent.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,iBAAiB;EACjB,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX;;;gEAG8D;EAC9D,4CAA4C;EAC5C,+CAA+C;EAC/C,2BAA2B;EAC3B,UAAU;EACV;;gCAE8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,wEAAwE;EACxE,mBAAmB;EACnB,oCAAoC;EACpC,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;EACxC,4BAA4B;EAC5B,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,+CAA+C;EAC/C,mDAAmD;AACrD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB;;;;;2CAKyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;EAEE,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,uDAAuD;AACzD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,aAAa;EACb,uBAAuB;AACzB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,oCAAoC;EACpC,+BAA+B;EAC/B,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,SAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,oCAAoC;EACpC,gCAAgC;EAChC,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,wCAAwC;AACxC;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,eAAe;EACf,wDAAwD;AAC1D;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,mBAAmB;EACnB;;+CAE6C;AAC/C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,YAAY;AACZ;EACE;IACE,iBAAiB;IACjB,2DAA2D;EAC7D;;EAEA;IACE,+BAA+B;IAC/B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;;;;IAKE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Cookie consent — full-width banner */\n\n.bv-cookie-consent {\n  --bv-cookie-z: 90;\n  position: fixed;\n  inset: 0;\n  z-index: var(--bv-cookie-z);\n  pointer-events: none;\n  display: flex;\n  align-items: flex-end;\n}\n\n.bv-cookie-consent.is-visible {\n  pointer-events: auto;\n}\n\n.bv-cookie-consent__backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.24);\n  backdrop-filter: blur(3px);\n  -webkit-backdrop-filter: blur(3px);\n  opacity: 0;\n  transition: opacity var(--bv-dur-slow) var(--bv-ease);\n}\n\n.bv-cookie-consent.is-visible .bv-cookie-consent__backdrop {\n  opacity: 1;\n}\n\n.bv-cookie-consent.is-leaving .bv-cookie-consent__backdrop {\n  opacity: 0;\n}\n\n.bv-cookie-consent__panel {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  background:\n    radial-gradient(ellipse 80% 120% at 0% 100%, rgba(20, 184, 166, 0.12), transparent 55%),\n    radial-gradient(ellipse 60% 80% at 100% 0%, rgba(251, 146, 60, 0.08), transparent 50%),\n    linear-gradient(180deg, #ffffff 0%, var(--bv-bg-cream) 100%);\n  border-top: 1px solid var(--bv-primary-line);\n  box-shadow: 0 -20px 60px rgba(15, 23, 42, 0.14);\n  transform: translateY(100%);\n  opacity: 0;\n  transition:\n    transform 0.52s var(--bv-ease-out),\n    opacity 0.38s var(--bv-ease);\n}\n\n.bv-cookie-consent.is-visible .bv-cookie-consent__panel {\n  transform: translateY(0);\n  opacity: 1;\n}\n\n.bv-cookie-consent.is-leaving .bv-cookie-consent__panel {\n  transform: translateY(100%);\n  opacity: 0;\n}\n\n.bv-cookie-consent__shell {\n  width: 100%;\n  max-width: calc(var(--bv-container-wide) + (2 * var(--bv-container-px)));\n  margin-inline: auto;\n  padding: 18px var(--bv-container-px);\n  padding-bottom: max(18px, env(safe-area-inset-bottom, 0px));\n  box-sizing: border-box;\n}\n\n/* Hero: copy | buttons */\n.bv-cookie-consent__hero {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  align-items: center;\n}\n\n.bv-cookie-consent__body {\n  min-width: 0;\n}\n\n.bv-cookie-consent__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px;\n  margin-bottom: 8px;\n  border-radius: var(--bv-radius-pill);\n  background: #fff;\n  border: 1px solid var(--bv-primary-line);\n  color: var(--bv-primary-700);\n  font-family: var(--bv-font-display);\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.bv-cookie-consent__badge i {\n  font-size: 0.65rem;\n  color: var(--bv-primary);\n}\n\n.bv-cookie-consent__title {\n  font-family: var(--bv-font-display);\n  font-size: clamp(1.125rem, 2.5vw, 1.375rem);\n  font-weight: 700;\n  letter-spacing: -0.03em;\n  color: var(--bv-ink);\n  line-height: 1.2;\n  margin: 0 0 6px;\n}\n\n.bv-cookie-consent__text {\n  font-size: 0.875rem;\n  line-height: 1.55;\n  color: var(--bv-muted);\n  margin: 0 0 8px;\n  max-width: 56ch;\n}\n\n.bv-cookie-consent__links {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0;\n  font-size: 0.8125rem;\n}\n\n.bv-cookie-consent__links a {\n  color: var(--bv-primary-700);\n  font-weight: 600;\n  text-decoration: none;\n  border-bottom: 1px solid var(--bv-primary-line);\n  transition: color var(--bv-dur-fast) var(--bv-ease);\n}\n\n.bv-cookie-consent__links a:hover {\n  color: var(--bv-primary);\n}\n\n.bv-cookie-consent__links span {\n  color: var(--bv-muted-2);\n}\n\n/* Buttons — order: Reject | Accept | Settings */\n.bv-cookie-consent__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.bv-cookie-consent__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 0 20px;\n  font-family: var(--bv-font-display);\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1;\n  border-radius: var(--bv-radius-pill);\n  border: 1px solid transparent;\n  cursor: pointer;\n  white-space: nowrap;\n  transition:\n    transform var(--bv-dur-fast) var(--bv-ease),\n    box-shadow var(--bv-dur-fast) var(--bv-ease),\n    background var(--bv-dur-fast) var(--bv-ease),\n    border-color var(--bv-dur-fast) var(--bv-ease),\n    color var(--bv-dur-fast) var(--bv-ease);\n}\n\n.bv-cookie-consent__btn--reject {\n  background: #fff;\n  border-color: var(--bv-line);\n  color: var(--bv-ink-3);\n}\n\n.bv-cookie-consent__btn--reject:hover {\n  border-color: var(--bv-muted-2);\n  color: var(--bv-ink);\n}\n\n.bv-cookie-consent__btn--accept {\n  background: var(--bv-grad-primary);\n  color: #fff;\n  box-shadow: var(--bv-shadow-teal);\n  padding-inline: 24px;\n}\n\n.bv-cookie-consent__btn--accept:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 16px 36px rgba(20, 184, 166, 0.38);\n}\n\n.bv-cookie-consent__btn--settings {\n  background: #fff;\n  border-color: var(--bv-line);\n  color: var(--bv-ink-2);\n}\n\n.bv-cookie-consent__btn--settings:hover,\n.bv-cookie-consent__btn--settings.is-active {\n  border-color: var(--bv-primary);\n  color: var(--bv-primary-700);\n  background: var(--bv-primary-50);\n}\n\n.bv-cookie-consent__chev {\n  font-size: 0.55rem !important;\n  transition: transform var(--bv-dur) var(--bv-ease);\n}\n\n.bv-cookie-consent__btn--settings.is-active .bv-cookie-consent__chev {\n  transform: rotate(180deg);\n}\n\n/* Settings panel */\n.bv-cookie-consent__settings {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.36s var(--bv-ease-out);\n}\n\n.bv-cookie-consent__settings.is-open {\n  grid-template-rows: 1fr;\n}\n\n.bv-cookie-consent__settings-inner {\n  overflow: hidden;\n}\n\n.bv-cookie-consent.has-settings-open .bv-cookie-consent__shell {\n  padding-bottom: max(20px, env(safe-area-inset-bottom, 0px));\n}\n\n.bv-cookie-consent__settings.is-open .bv-cookie-consent__settings-inner {\n  padding-top: 16px;\n  border-top: 1px solid var(--bv-line-soft);\n  display: flex;\n  justify-content: center;\n}\n\n/* —— Cookie preferences: centered wide toolbar —— */\n.bv-cookie-consent__prefs-bar {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  width: 100%;\n  max-width: 720px;\n  margin: 0 auto;\n  padding: 6px 8px;\n  background: #fff;\n  border: 1px solid var(--bv-line);\n  border-radius: var(--bv-radius-pill);\n  box-shadow: var(--bv-shadow-xs);\n  gap: 4px;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.bv-cookie-consent__seg {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  flex: 1 1 0;\n  min-width: 0;\n  padding: 10px 16px;\n  transition: background var(--bv-dur-fast) var(--bv-ease);\n}\n\n.bv-cookie-consent__seg-name {\n  font-family: var(--bv-font-display);\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--bv-ink);\n  white-space: nowrap;\n}\n\n.bv-cookie-consent__seg-tag {\n  font-size: 0.6875rem;\n  font-weight: 600;\n  color: var(--bv-primary-700);\n  padding: 4px 10px;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-primary-50);\n  border: 1px solid var(--bv-primary-line);\n  white-space: nowrap;\n}\n\n.bv-cookie-consent__seg-divider {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 1px;\n  height: 24px;\n  background: var(--bv-line);\n  pointer-events: none;\n}\n\n/* Toggle — reset native button chrome */\n.bv-cookie-consent__switch {\n  -webkit-appearance: none;\n  appearance: none;\n  position: relative;\n  flex-shrink: 0;\n  width: 36px;\n  height: 20px;\n  margin: 0;\n  padding: 0;\n  border: none;\n  border-radius: var(--bv-radius-pill);\n  background: var(--bv-line);\n  cursor: pointer;\n  transition: background var(--bv-dur-fast) var(--bv-ease);\n}\n\n.bv-cookie-consent__switch::before,\n.bv-cookie-consent__switch::after {\n  box-sizing: border-box;\n}\n\n.bv-cookie-consent__switch::after {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.18);\n  transition: transform 0.26s var(--bv-ease-spring);\n}\n\n.bv-cookie-consent__switch.is-on {\n  background: var(--bv-primary);\n}\n\n.bv-cookie-consent__switch.is-on::after {\n  transform: translateX(16px);\n}\n\n.bv-cookie-consent__switch:focus-visible {\n  outline: 2px solid var(--bv-primary);\n  outline-offset: 2px;\n}\n\n.bv-cookie-consent__seg-save {\n  flex: 0 0 auto;\n  margin: 0;\n  padding: 10px 18px;\n  font-family: var(--bv-font-display);\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1;\n  color: #fff;\n  background: var(--bv-ink);\n  border: none;\n  border-radius: var(--bv-radius-pill);\n  cursor: pointer;\n  white-space: nowrap;\n  transition:\n    background var(--bv-dur-fast) var(--bv-ease),\n    transform var(--bv-dur-fast) var(--bv-ease);\n}\n\n.bv-cookie-consent__seg-save:hover {\n  background: var(--bv-ink-2);\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n  .bv-cookie-consent__prefs-bar {\n    max-width: 100%;\n    padding: 5px 6px;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    border-radius: var(--bv-radius-lg);\n    justify-content: flex-start;\n  }\n\n  .bv-cookie-consent__prefs-bar::-webkit-scrollbar {\n    display: none;\n  }\n\n  .bv-cookie-consent__seg {\n    flex: 0 0 auto;\n    min-width: 128px;\n    padding: 9px 14px;\n    gap: 10px;\n  }\n\n  .bv-cookie-consent__seg-name {\n    font-size: 0.8125rem;\n  }\n\n  .bv-cookie-consent__seg-save {\n    flex: 0 0 auto;\n    padding: 9px 18px;\n    font-size: 0.8125rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .bv-cookie-consent__prefs-bar {\n    max-width: min(100%, 800px);\n    padding: 8px 10px;\n  }\n\n  .bv-cookie-consent__seg {\n    padding: 11px 20px;\n  }\n}\n\n/* Tablet+ */\n@media (min-width: 768px) {\n  .bv-cookie-consent__shell {\n    padding-top: 22px;\n    padding-bottom: max(22px, env(safe-area-inset-bottom, 0px));\n  }\n\n  .bv-cookie-consent__hero {\n    grid-template-columns: 1fr auto;\n    gap: 32px;\n    align-items: center;\n  }\n\n  .bv-cookie-consent__actions {\n    flex-wrap: nowrap;\n    gap: 10px;\n  }\n\n  .bv-cookie-consent__settings.is-open .bv-cookie-consent__settings-inner {\n    padding-top: 12px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .bv-cookie-consent__panel,\n  .bv-cookie-consent__backdrop,\n  .bv-cookie-consent__settings,\n  .bv-cookie-consent__switch::after,\n  .bv-cookie-consent__chev {\n    transition: none;\n  }\n\n  .bv-cookie-consent.is-visible .bv-cookie-consent__panel {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
